import React from 'react';
import { Badge, IconButton } from '@economic/gaudi';
import { useLatestNotifications } from '../../../shared/hooks/useNotifications';
import NotificationsPanel from './Panel';
import { t } from '../../../shared/components/l10n/l10n';

export default function NotificationsIconButton(props) {
    const [notifications, lastSeenTimestamp, setLastSeenTimestamp, markNotificationsAsRead] = useLatestNotifications();
    const hasUnseenNotifications =
        lastSeenTimestamp &&
        notifications.some(
            notification => notification.read === false && notification.createdAt.getTime() > lastSeenTimestamp.getTime()
        );

    return (
        <span className="relative" id="span_notification_navigation">
            <IconButton
                {...props}
                aria-label="Notifications"
                icon="bell-solid"
                tooltip={t`HEADER_TAB_NOTIFICATIONS`}
                popover={popoverProps => (
                    <NotificationsPanel
                        {...popoverProps}
                        notifications={notifications}
                        onOpened={setLastSeenTimestamp}
                        onMarkAsRead={markNotificationsAsRead}
                    />
                )}
            />
            {hasUnseenNotifications ? (
                <Badge
                    aria-label="Unread notifications"
                    style={{ position: 'absolute', top: '5px', right: '5px' }}
                    compact
                    state="error">
                    Unread notifications
                </Badge>
            ) : null}
        </span>
    );
}
